import { isSameDay, isWithinInterval } from 'date-fns';

interface DateCalendarProps {
  year: number;
  month: number;
  startDate: Date | null;
  endDate: Date | null;
  onDateClick: (date: Date) => void;
}

function DateCalendar({ year, month, startDate, endDate, onDateClick }: DateCalendarProps) {
  const classDateCommon =
    '[&>*]:grid [&>*]:place-items-center [&>*]:rounded-[4px] [&>*]:size-[30px]';
  const classDateSelected =
    '[&>[data-selected]]:bg-primary-500 [&>[data-selected]]:text-white [&>[data-selected]]:border [&>[data-selected]]:border-white';
  const classDateRange =
    '[&>[data-range]]:bg-primary-50 [&>[data-range]]:border-t-4 [&>[data-range]]:border-t-white [&>[data-range]]:border-b-4 [&>[data-range]]:border-b-white';
  const classDateToday = '[&>[data-today]]:border [&>[data-today]]:border-gray-200';

  const today = new Date();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = new Date(year, month, 1).getDay();

  const dates: JSX.Element[] = [];
  for (let i = 0; i < firstDay; i++) {
    dates.push(<div key={`empty-${i}`} />);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const current = new Date(year, month, day);
    const isSelected =
      (startDate && isSameDay(current, startDate)) || (endDate && isSameDay(current, endDate));
    const inRange =
      startDate && endDate && isWithinInterval(current, { start: startDate, end: endDate });
    const isToday = isSameDay(current, today);

    dates.push(
      <button
        key={day}
        onClick={() => onDateClick(current)}
        data-selected={isSelected || undefined}
        data-range={inRange && !isSelected ? true : undefined}
        data-today={isToday || undefined}
      >
        {day}
      </button>,
    );
  }

  return (
    <div>
      <h2 className='text-center text-sm font-medium'>
        {year}年{month + 1}月
      </h2>
      <div className='mt-[10px] px-[3px] pb-[3px]'>
        <div className='flex w-full items-center [&>*]:grid [&>*]:size-[30px] [&>*]:place-items-center [&>*]:text-xs [&>*]:font-semibold [&>*]:text-[rgba(41,41,41,0.6)]'>
          {['日', '月', '火', '水', '木', '金', '土'].map((d) => (
            <div key={d}>{d}</div>
          ))}
        </div>
        <div
          className={`flex flex-wrap text-xs ${classDateCommon} ${classDateSelected} ${classDateRange} ${classDateToday}`}
        >
          {dates}
        </div>
      </div>
    </div>
  );
}

export default DateCalendar;
